import {useEffect, useState} from 'react';
import {useShallowMemo} from '~/library/ui-kit';

export function useDebounce<T>(delay: number, value: T) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const [isDebouncing, setIsDebouncing] = useState(false);

    useEffect(() => {
        setIsDebouncing(true);

        const timeout = setTimeout(() => {
            setDebouncedValue(value);
            setIsDebouncing(false);
        }, delay);

        return () => {
            clearTimeout(timeout);
        };
    }, [value, delay]);

    return {value: debouncedValue, isDebouncing};
}

export function useShallowDebounce<T extends object>(delay: number, value: T) {
    return useDebounce(delay, useShallowMemo(value));
}
